// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"b290b728c18490397684","691":"ace8bb6bc3495b3ee9f7"}[chunkId] + ".js";
};